import { createContext, useContext, useState, useCallback } from "react";

const UserCourseContext = createContext();

const initialState = {
  cartCourseCount: 0,
  cartCourseList: {},
  pendingCourseCount: 0,
  enrolledCourses: [],
};

export const UserCourseProvider = ({ children }) => {
  
  const [cartCourseCount, setCartCourseCount] = useState(initialState.cartCourseCount);
  const [cartCourseList, setCartCourseList] = useState(initialState.cartCourseList);

  const [pendingCourseCount, setPendingCourseCount] = useState(initialState.pendingCourseCount);

  const [enrolledCourses, setEnrolledCourses] = useState(initialState.enrolledCourses);

  const updateCartCourseList = (data) => setCartCourseList((prev) => ({ ...prev, ...data}));
  const updateCartCourseCount = (response) => {
        let count = 0;
        if (response == undefined) {
            count += (cartCourseList["pending"] != undefined && cartCourseList["pending"].length > 0) ? cartCourseList["pending"].length : 0;
        } else {
            count += (response["pending"] != undefined && response["pending"].length > 0) ? response["pending"].length : 0;
        }
      setCartCourseCount(count);
  }

  const updatePendingCourseCount = (data) => setPendingCourseCount(data);
  const addEnrolledCourse = (data) => setEnrolledCourses((prev) => [...prev, data]);
  const resetEnrolledCourses = (data) => setEnrolledCourses((prev) => []);

  const clearUserCourseContext = useCallback(() => {
    setCartCourseCount(initialState.cartCourseCount);
    setCartCourseList(initialState.cartCourseList);
    setPendingCourseCount(initialState.pendingCourseCount);
    setEnrolledCourses(initialState.enrolledCourses);
  }, []);

  return (
    <UserCourseContext.Provider value={{
          cartCourseCount, cartCourseList, pendingCourseCount, enrolledCourses,
          updateCartCourseList, updateCartCourseCount, updatePendingCourseCount, addEnrolledCourse,
          clearUserCourseContext, resetEnrolledCourses
        }}>
      {children}
    </UserCourseContext.Provider>
  );
};

export const useUserCourse = () => useContext(UserCourseContext);
